'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Hamburger", {
    enumerable: true,
    get: function() {
        return Hamburger;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactbutton = require("@fluentui/react-button");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useHamburger = require("./useHamburger");
const _useHamburgerStylesstyles = require("./useHamburgerStyles.styles");
const Hamburger = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useHamburger.useHamburger_unstable)(props, ref);
    (0, _useHamburgerStylesstyles.useHamburgerStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useHamburgerStyles_unstable')(state);
    return (0, _reactbutton.renderButton_unstable)(state);
});
Hamburger.displayName = 'Hamburger';
